import React from 'react';
import { LocationText } from './DataCardLocation.styles';

export const NoAddress = () => {
  return (
    <LocationText color="secondaryText" fontWeight="regular">
      Address Not Found
    </LocationText>
  );
};
